var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "home-page" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-4 col-md-6" }, [
          _c(
            "div",
            { staticClass: "news-sections" },
            [
              _c("p", { staticClass: "news-title" }, [
                _vm._v("news & announcements")
              ]),
              _vm._v(" "),
              _vm.news.totalRecords > 0
                ? _vm._l(_vm.news.row, function(newsItem, index) {
                    return _c("div", { key: index, staticClass: "news-menu" }, [
                      _c(
                        "div",
                        { staticClass: "me-3" },
                        [
                          newsItem.image &&
                          newsItem.image.length > 0 &&
                          newsItem.image[0].image
                            ? _vm._l(newsItem.image, function(image) {
                                return _c("img", {
                                  key: image.id,
                                  attrs: {
                                    src: image.image,
                                    alt: "News Image " + image.id
                                  }
                                })
                              })
                            : [
                                _c("img", {
                                  staticClass: "row-image",
                                  attrs: {
                                    src: "/static/images/default_news.png",
                                    alt: "Default News Image"
                                  }
                                })
                              ]
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticStyle: { flex: "1" } }, [
                        _c("a", { attrs: { href: "/news/" + newsItem.slug } }, [
                          _c("span", [_vm._v(_vm._s(newsItem.title))])
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(newsItem.news_date))])
                      ])
                    ])
                  })
                : [
                    _c("div", { staticClass: "fs-4 p-4 text-center" }, [
                      _vm._v(
                        "\n                            No News\n                        "
                      )
                    ])
                  ]
            ],
            2
          ),
          _vm._v(" "),
          _vm.news.totalRecords > 0
            ? _c(
                "div",
                { staticClass: "more-news" },
                [
                  _c(
                    "router-link",
                    { attrs: { to: { name: "NewsAnnouncements" } } },
                    [_vm._v("View more news and announcements >")]
                  )
                ],
                1
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "events-detalis" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-8 col-md-6" }, [
            _c("div", { staticClass: "events-box" }, [
              _c("p", { staticClass: "event-title" }, [
                _vm._v("upcoming events & deadlines")
              ]),
              _vm._v(" "),
              _vm.events.totalRecords > 0
                ? _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-8 offset-md-2" }, [
                      _c(
                        "div",
                        { staticClass: "row" },
                        _vm._l(_vm.visibleEvents, function(event, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              staticClass: "col-md-6 col-sm-6 mb-3"
                            },
                            [
                              _c("div", { staticClass: "upcoming-event" }, [
                                _c("p", [_vm._v(_vm._s(event.exp_date))]),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(event.title))]),
                                _vm._v(" "),
                                _c("div", { staticClass: "learn-btn" }, [
                                  _c(
                                    "a",
                                    { attrs: { href: "/event/" + event.slug } },
                                    [_vm._v("learn more")]
                                  )
                                ])
                              ])
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm.events.totalRecords > 6
                        ? _c(
                            "div",
                            { staticClass: "more-news" },
                            [
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: { name: "EventDeadlineDetailView" }
                                  }
                                },
                                [
                                  _vm._v(
                                    "View more upcoming events & deadlines >"
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  ])
                : _c("div", { staticClass: "fs-4 p-4 text-center" }, [
                    _vm._v(
                      "\n                            No events\n                        "
                    )
                  ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-4 col-md-6" }, [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "modal fade",
                attrs: {
                  id: "problemModal",
                  tabindex: "-1",
                  "aria-labelledby": "problemModalLabel",
                  "aria-hidden": "true",
                  "data-bs-keyboard": "false",
                  "data-bs-backdrop": "static"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "modal-dialog modal-dialog-centered" },
                  [
                    _c("div", { staticClass: "modal-content" }, [
                      _c("div", { staticClass: "modal-header" }, [
                        _c(
                          "h5",
                          {
                            staticClass: "modal-title",
                            attrs: { id: "problemModalLabel" }
                          },
                          [_vm._v("Report a Problem")]
                        ),
                        _vm._v(" "),
                        _c("button", {
                          staticClass: "btn-close",
                          attrs: {
                            type: "button",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.closeModal.apply(null, arguments)
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "modal-body" },
                        [
                          _c("div", { staticClass: "row" }, [
                            _vm._m(2),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-md-6 form-group pb-10" },
                              [
                                _c("label", { attrs: { for: "name" } }, [
                                  _vm._v("Name:")
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.problemName,
                                      expression: "problemName"
                                    }
                                  ],
                                  staticClass: "swal2-input",
                                  attrs: {
                                    type: "text",
                                    id: "name",
                                    name: "name",
                                    maxlength: "190"
                                  },
                                  domProps: { value: _vm.problemName },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.problemName = $event.target.value
                                      },
                                      function($event) {
                                        _vm.nameError = ""
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "error-message help is-danger"
                                  },
                                  [_vm._v(_vm._s(_vm.nameError))]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-md-6 form-group pb-10" },
                              [
                                _c("label", { attrs: { for: "email" } }, [
                                  _vm._v("Email:")
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.problemEmail,
                                      expression: "problemEmail"
                                    }
                                  ],
                                  staticClass: "swal2-input",
                                  attrs: {
                                    type: "email",
                                    id: "email",
                                    name: "email",
                                    maxlength: "190"
                                  },
                                  domProps: { value: _vm.problemEmail },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.problemEmail = $event.target.value
                                      },
                                      function($event) {
                                        _vm.emailError = ""
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "error-message help is-danger"
                                  },
                                  [_vm._v(_vm._s(_vm.emailError))]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-md-12 form-group pb-10" },
                              [
                                _c("label", { attrs: { for: "phone" } }, [
                                  _vm._v("Contact No:")
                                ]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.problemPhone,
                                      expression: "problemPhone"
                                    }
                                  ],
                                  staticClass: "swal2-input",
                                  attrs: {
                                    type: "tel",
                                    id: "phone",
                                    name: "phone",
                                    maxlength: "17"
                                  },
                                  domProps: { value: _vm.problemPhone },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.problemPhone = $event.target.value
                                      },
                                      function($event) {
                                        _vm.phoneError = ""
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "error-message help is-danger"
                                  },
                                  [_vm._v(_vm._s(_vm.phoneError))]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-md-12 form-group pb-10" },
                              [
                                _vm._m(3),
                                _vm._v(" "),
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.problemComment,
                                      expression: "problemComment"
                                    }
                                  ],
                                  staticClass: "swal2-textarea",
                                  attrs: {
                                    id: "comments",
                                    name: "comments",
                                    maxlength: "250",
                                    required: ""
                                  },
                                  domProps: { value: _vm.problemComment },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.problemComment = $event.target.value
                                      },
                                      function($event) {
                                        _vm.commentsError = ""
                                      }
                                    ]
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "error-message help is-danger"
                                  },
                                  [_vm._v(_vm._s(_vm.commentsError))]
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("vue-recaptcha", {
                            ref: "recaptcha",
                            attrs: { sitekey: _vm.recaptchaSiteKey },
                            on: {
                              verify: _vm.verifyCaptcha,
                              expired: _vm.onCaptchaExpired
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "error-message help is-danger" },
                            [_vm._v(_vm._s(_vm.reCAPTCHAError))]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "modal-footer" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.report.apply(null, arguments)
                              }
                            }
                          },
                          [_vm._v("Send")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary",
                            attrs: {
                              type: "button",
                              "data-bs-dismiss": "modal"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.closeModal.apply(null, arguments)
                              }
                            }
                          },
                          [_vm._v("Cancel")]
                        )
                      ])
                    ])
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _vm._m(4),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "modal fade",
                attrs: {
                  id: "opinionModal",
                  tabindex: "-1",
                  "aria-labelledby": "opinionModalLabel",
                  "aria-hidden": "true",
                  "data-bs-keyboard": "false",
                  "data-bs-backdrop": "static"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "modal-dialog modal-dialog-centered" },
                  [
                    _c("div", { staticClass: "modal-content" }, [
                      _c("div", { staticClass: "modal-header" }, [
                        _c(
                          "h5",
                          {
                            staticClass: "modal-title",
                            attrs: { id: "opinionModalLabel" }
                          },
                          [_vm._v("Your Opinion Matters")]
                        ),
                        _vm._v(" "),
                        _c("button", {
                          staticClass: "btn-close",
                          attrs: {
                            type: "button",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.closeModal.apply(null, arguments)
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "modal-body" },
                        [
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _vm._m(5),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-6 form-group pb-10" },
                                [
                                  _vm._m(6),
                                  _vm._v(" "),
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.opinionType,
                                          expression: "opinionType"
                                        }
                                      ],
                                      staticClass: "swal2-input",
                                      attrs: { id: "type", name: "type" },
                                      on: {
                                        change: [
                                          function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.opinionType = $event.target
                                              .multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                          function($event) {
                                            _vm.typeError = ""
                                          }
                                        ]
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { attrs: { value: "feedback" } },
                                        [_vm._v("Feedback")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "complaint" } },
                                        [_vm._v("Complaint")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "request" } },
                                        [_vm._v("Request")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: { value: "policy suggestion" }
                                        },
                                        [_vm._v("Policy suggestion")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { attrs: { value: "other" } },
                                        [_vm._v("Other")]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "error-message help is-danger",
                                      staticStyle: { color: "red" },
                                      attrs: { id: "typeError" }
                                    },
                                    [_vm._v(_vm._s(_vm.typeError))]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.opinionType == "other"
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "col-md-6 form-group",
                                        attrs: { id: "otherField" }
                                      },
                                      [
                                        _vm._m(7),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.opinionOther,
                                              expression: "opinionOther"
                                            }
                                          ],
                                          staticClass: "swal2-input",
                                          attrs: {
                                            type: "text",
                                            id: "other",
                                            name: "other"
                                          },
                                          domProps: { value: _vm.opinionOther },
                                          on: {
                                            input: [
                                              function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.opinionOther =
                                                  $event.target.value
                                              },
                                              function($event) {
                                                _vm.otherError = ""
                                              }
                                            ]
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "error-message help is-danger",
                                            staticStyle: { color: "red" },
                                            attrs: { id: "otherError" }
                                          },
                                          [_vm._v(_vm._s(_vm.otherError))]
                                        )
                                      ]
                                    )
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "clearfix" }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-6 form-group pb-10" },
                                [
                                  _c("label", { attrs: { for: "name" } }, [
                                    _vm._v("Name:")
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.opinionName,
                                        expression: "opinionName"
                                      }
                                    ],
                                    staticClass: "swal2-input",
                                    attrs: {
                                      type: "text",
                                      id: "name",
                                      name: "name",
                                      maxlength: "190"
                                    },
                                    domProps: { value: _vm.opinionName },
                                    on: {
                                      input: [
                                        function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.opinionName = $event.target.value
                                        },
                                        function($event) {
                                          _vm.nameError = ""
                                        }
                                      ]
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "error-message help is-danger",
                                      staticStyle: { color: "red" }
                                    },
                                    [_vm._v(_vm._s(_vm.nameError))]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-6 form-group pb-10" },
                                [
                                  _c("label", { attrs: { for: "email" } }, [
                                    _vm._v("Email:")
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.opinionEmail,
                                        expression: "opinionEmail"
                                      }
                                    ],
                                    staticClass: "swal2-input",
                                    attrs: {
                                      type: "email",
                                      id: "email",
                                      name: "email",
                                      maxlength: "190"
                                    },
                                    domProps: { value: _vm.opinionEmail },
                                    on: {
                                      input: [
                                        function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.opinionEmail = $event.target.value
                                        },
                                        function($event) {
                                          _vm.emailError = ""
                                        }
                                      ]
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "error-message help is-danger",
                                      staticStyle: { color: "red" }
                                    },
                                    [_vm._v(_vm._s(_vm.emailError))]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-12 form-group pb-10" },
                                [
                                  _c("label", { attrs: { for: "phone" } }, [
                                    _vm._v("Contact No:")
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.opinionPhone,
                                        expression: "opinionPhone"
                                      }
                                    ],
                                    staticClass: "swal2-input",
                                    attrs: {
                                      type: "tel",
                                      id: "phone",
                                      name: "phone",
                                      maxlength: "17"
                                    },
                                    domProps: { value: _vm.opinionPhone },
                                    on: {
                                      input: [
                                        function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.opinionPhone = $event.target.value
                                        },
                                        function($event) {
                                          _vm.phoneError = ""
                                        }
                                      ]
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "error-message help is-danger",
                                      staticStyle: { color: "red" }
                                    },
                                    [_vm._v(_vm._s(_vm.phoneError))]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-md-12 form-group" },
                                [
                                  _vm._m(8),
                                  _vm._v(" "),
                                  _c("textarea", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.opinionComment,
                                        expression: "opinionComment"
                                      }
                                    ],
                                    staticClass: "swal2-textarea",
                                    attrs: {
                                      id: "comments",
                                      name: "comments",
                                      maxlength: "250",
                                      required: ""
                                    },
                                    domProps: { value: _vm.opinionComment },
                                    on: {
                                      input: [
                                        function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.opinionComment =
                                            $event.target.value
                                        },
                                        function($event) {
                                          _vm.commentsError = ""
                                        }
                                      ]
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "error-message help is-danger",
                                      staticStyle: { color: "red" }
                                    },
                                    [_vm._v(_vm._s(_vm.commentsError))]
                                  )
                                ]
                              )
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("vue-recaptcha", {
                            ref: "recaptcha",
                            attrs: { sitekey: _vm.recaptchaSiteKey },
                            on: {
                              verify: _vm.verifyCaptcha,
                              expired: _vm.onCaptchaExpired
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "error-message help is-danger",
                              staticStyle: { color: "red" }
                            },
                            [_vm._v(_vm._s(_vm.reCAPTCHAError))]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "modal-footer" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.opinion.apply(null, arguments)
                              }
                            }
                          },
                          [_vm._v("Send")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary",
                            attrs: {
                              type: "button",
                              "data-bs-dismiss": "modal"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.closeModal.apply(null, arguments)
                              }
                            }
                          },
                          [_vm._v("Cancel")]
                        )
                      ])
                    ])
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _vm._m(9)
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "resources-section" }, [
        _c("div", { staticClass: "resources-title" }, [_vm._v("resources")]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _vm._m(10),
          _vm._v(" "),
          _vm._m(11),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-3 col-6 mb-3" }, [
            _c("div", { staticClass: "resoures-detalis" }, [
              _c("img", {
                attrs: { src: "static/images/code-of-conduct.png", alt: "" }
              }),
              _vm._v(" "),
              _c("div", [
                _c(
                  "a",
                  {
                    attrs: { href: "javascript:void(0)" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.loadCodeofConduct.apply(null, arguments)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                                code of business ethics\n                            "
                    )
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _vm._m(12)
        ])
      ]),
      _vm._v(" "),
      _vm.team.totalRecords > 0
        ? _c("div", [
            _c("div", { staticClass: "compliance-title" }, [
              _vm._v("meet the compliance team")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row" },
              _vm._l(_vm.team.row, function(user, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "col-lg-4 col-md-6 mb-3" },
                  [
                    _c("div", { staticClass: "team-detalis" }, [
                      user.profile_path != ""
                        ? _c("img", {
                            attrs: {
                              src: user.profile_path,
                              alt: "",
                              id: "profile-image-" + index
                            },
                            on: {
                              error: function($event) {
                                return _vm.setDefaultImage(index)
                              }
                            }
                          })
                        : _c("img", {
                            attrs: {
                              src: "/static/images/default_user.png",
                              alt: ""
                            }
                          }),
                      _vm._v(" "),
                      _c("div", {}, [
                        _c("div", { staticClass: "profile-detail" }, [
                          _c("i", { staticClass: "fa fa-user" }),
                          _vm._v(" "),
                          _c("div", [_vm._v(_vm._s(user.name))])
                        ]),
                        _vm._v(" "),
                        user.contact_no
                          ? _c("div", [
                              _c(
                                "a",
                                {
                                  staticClass: "profile-detail",
                                  attrs: { href: "tel:" + user.contact_no }
                                },
                                [
                                  _c("i", { staticClass: "fa fa-phone" }),
                                  _vm._v(" "),
                                  _c("div", [_vm._v(_vm._s(user.contact_no))])
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        user.email
                          ? _c("div", [
                              _c(
                                "a",
                                {
                                  staticClass: "profile-detail",
                                  attrs: { href: "mailto:" + user.email }
                                },
                                [
                                  _c("i", { staticClass: "fa fa-envelope" }),
                                  _vm._v(" "),
                                  _c("div", [_vm._v(_vm._s(user.email))])
                                ]
                              )
                            ])
                          : _vm._e()
                      ])
                    ])
                  ]
                )
              }),
              0
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-lg-8 col-md-6" }, [
      _c("video", { attrs: { controls: "" } }, [
        _c("source", {
          attrs: {
            src: "static/video/2024-Compliance-Portal-Message.mp4#t=03",
            type: "video/mp4"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "event-button",
        attrs: {
          type: "button",
          "data-bs-toggle": "modal",
          "data-bs-target": "#problemModal"
        }
      },
      [_c("p", [_vm._v("Report a problem")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "loading-container", staticStyle: { display: "none" } },
      [
        _c("div", { staticClass: "loading" }, [
          _c("img", { attrs: { src: "/static/images/loading.gif" } })
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "comments" } }, [
      _vm._v("Comment:"),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "event-button",
        attrs: {
          type: "button",
          "data-bs-toggle": "modal",
          "data-bs-target": "#opinionModal"
        }
      },
      [_c("p", [_vm._v("your opinion matters")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "loading-container", staticStyle: { display: "none" } },
      [
        _c("div", { staticClass: "loading" }, [
          _c("img", { attrs: { src: "/static/images/loading.gif" } })
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "type" } }, [
      _vm._v("Type:"),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "other" } }, [
      _vm._v("Please specify:"),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "comments" } }, [
      _vm._v("Comments:"),
      _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "event-button mb-0",
        attrs: {
          target: "_blank",
          href: "https://surveys.velocityvehiclegroup.com/survey/C&Enomination"
        }
      },
      [_c("p", [_vm._v("nomination for recognition")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-lg-3 col-6 mb-3" }, [
      _c("div", { staticClass: "resoures-detalis" }, [
        _c("img", {
          attrs: { src: "static/images/resources-img.png", alt: "" }
        }),
        _vm._v(" "),
        _c("div", [
          _c(
            "a",
            {
              attrs: { target: "_blank", href: "https://www.vvguniversity.com" }
            },
            [_vm._v("on demand training")]
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-lg-3 col-6 mb-3" }, [
      _c("div", { staticClass: "resoures-detalis" }, [
        _c("img", { attrs: { src: "static/images/police-logo.png", alt: "" } }),
        _vm._v(" "),
        _c("div", [
          _c("a", { attrs: { href: "/policies" } }, [_vm._v("policies")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-lg-3 col-6 mb-3" }, [
      _c("div", { staticClass: "resoures-detalis" }, [
        _c("img", { attrs: { src: "static/images/projects.png", alt: "" } }),
        _vm._v(" "),
        _c("div", [
          _c("a", { attrs: { href: "/projects" } }, [
            _vm._v(
              "\n                            projects\n                        "
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8dc7cce2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8dc7cce2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = null
// module chunks = 